<app-manage-template [title]="'Network of Business Listing'" [FIELDS]="fields" [COLUMNFIELDS]="columns"
[userData]="(userDatas | async)" [parentData]="businessNetworkDetails" [KEY]="'B2B_NETWORKS'"
(updateParent)="updateBusinessNetwork($event)"
(updateMembers)="updateBusinessNetworkMembers($event)" [onSearch]="onSearch"
[onFilter]="onFilter" [this]="this" [onScroll]="onScroll"></app-manage-template>
